/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Set_NewInputs */

const en_password_reset_set_new = /** @type {(inputs: Password_Reset_Set_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set your new password`)
};

const es_password_reset_set_new = /** @type {(inputs: Password_Reset_Set_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Establece tu nueva contraseña`)
};

/**
* | output |
* | --- |
* | "Set your new password" |
*
* @param {Password_Reset_Set_NewInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_set_new = /** @type {((inputs?: Password_Reset_Set_NewInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Set_NewInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_set_new(inputs)
	return en_password_reset_set_new(inputs)
});